<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
    }
  },

  methods: {
  },

  created() {
    this.$vs.loading();

    const state = this.$route.query.state;
    const authCode = this.$route.query.code;

    const error = this.$route.query.error;
    const errorDescription = this.$route.query.error_description;

    console.log(authCode);
    console.log(error);
    console.log(errorDescription);

    const payload = {
      state: state,
      code: authCode,
    };

    this.$http.post(process.env.VUE_APP_API +'/accounts', payload)
          .then((/*resp*/) => {
            console.log("ACCOUNT CONNECTED");
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$vs.loading.close()
          })
  },

  destroyed() {
    this.$vs.loading.close();
  }
}
</script>

<style lang="scss">
</style>
